<div class="create-organization-modal">

  <form
    class="create-organization-modal__form"
    [formGroup]="formModel.form"
    (ngSubmit)="submitForm()"
  >
    <section class="create-organization-modal__panel">
      <div class="create-organization-modal__grid">
        <div class="create-organization-modal__field">
          <label for="title-input" class="form-label required">
            {{ "INPUTS.TITLE" | translate }}
          </label>

          @let organizationTitleControl = formModel.form.controls.title;

          <input
            id="title-input"
            type="text"
            class="form-input"
            [class.is-invalid]="
              organizationTitleControl.touched && organizationTitleControl.errors
            "
            [class.is-valid]="
              organizationTitleControl.touched && !organizationTitleControl.errors
            "
            [formControlName]="formModel.fieldNames.title"
          />

          <ng-container
            [ngTemplateOutlet]="validationErrorsTemplate"
            [ngTemplateOutletContext]="{ errors: organizationTitleControl.errors }"
          ></ng-container>
        </div>

        <div class="create-organization-modal__field">
          <label for="responsible-input" class="form-label required">
            {{ "INPUTS.RESPONSIBLE" | translate }}
          </label>

          <app-search
            [formControlName]="formModel.fieldNames.responsibleUserId"
            [items]="(companyEmployees$ | async) ?? []"
            [filterFn]="employeeFullNameFilter"
            [formatter]="employeeFormatter"
            [compareFn]="employeeCompareFn"
            [errorMessage]="'ERRORS.INCORRECT_SELECTED_RESPONSIBLE' | translate"
            [placeholderText]="'INPUTS.RESPONSIBLE' | translate"
            [customClass]="'form-search-input'"
            [resultTemplate]="customTemplate"
          >
            <ng-template #customTemplate let-r="result" let-t="term">
              <ngb-highlight
                class="create-organization-modal__search-name"
                highlightClass="hover-highlight"
                [result]="r?.fullName"
                [term]="t"
              ></ngb-highlight>
              <div class="create-organization-modal__search-email">{{ r?.email }}</div>
            </ng-template>
          </app-search>
        </div>

        <div class="create-organization-modal__field">
          <label for="email-input" class="form-label">
            {{ "INPUTS.EMAIL" | translate }}
          </label>

          @let organizationEmailControl = formModel.form.controls.email;

          <input
            id="email-input"
            type="email"
            class="form-input"
            [class.is-invalid]="
              organizationEmailControl.touched && organizationEmailControl.errors
            "
            [class.is-valid]="
              organizationEmailControl.touched && !organizationEmailControl.errors
            "
            [formControlName]="formModel.fieldNames.email"
          />

          <ng-container
            [ngTemplateOutlet]="validationErrorsTemplate"
            [ngTemplateOutletContext]="{ errors: organizationEmailControl.errors }"
          ></ng-container>
        </div>

        <div class="create-organization-modal__field">
          <label for="phone-number-input" class="form-label">
            {{ "INPUTS.PHONE" | translate }}
          </label>

          @let organizationPhoneNumberControl =
            formModel.form.controls.phoneNumber;

          <input
            id="phone-number-input"
            type="text"
            class="form-input"
            [class.is-invalid]="
              organizationPhoneNumberControl.touched &&
              organizationPhoneNumberControl.errors
            "
            [class.is-valid]="
              organizationPhoneNumberControl.touched &&
              !organizationPhoneNumberControl.errors
            "
            [formControlName]="formModel.fieldNames.phoneNumber"
          />

          <ng-container
            [ngTemplateOutlet]="validationErrorsTemplate"
            [ngTemplateOutletContext]="{ errors: organizationPhoneNumberControl.errors }"
          ></ng-container>
        </div>
      </div>
    </section>

    <div class="create-project-actions create-organization-modal__actions">
      <button
        type="button"
        class="form-secondary-btn"
        (click)="onCancel()"
      >
        {{ "BUTTONS.CANCEL" | translate }}
      </button>

      <button
        type="submit"
        class="form-primary-btn"
        [disabled]="formModel.form.invalid || isSubmitting"
      >
        {{ "BUTTONS.SAVE" | translate }}
      </button>
    </div>
  </form>
</div>

<ng-template #validationErrorsTemplate let-errors="errors">
  @if (errors) {
    <ul class="invalid-feedback">
      @if (errors["required"]) {
        <li>{{ "ERRORS.REQUIRED" | translate }}</li>
      }

      @if (errors["maxlength"]) {
        <li>
          {{
            "ERRORS.MAXLENGTH"
              | translate
                : { requiredLength: errors["maxlength"].requiredLength }
          }}
        </li>
      }

      @if (errors["email"]) {
        <li>{{ "ERRORS.EMAIL" | translate }}</li>
      }

      @if (errors["tel"]) {
        <li>{{ "ERRORS.PHONE" | translate }}</li>
      }
    </ul>
  }
</ng-template>
